import { CategoriaConcesiones } from "./types/categoriaConcesiones";
import { fetchWithRetry } from "../client";
import { cmsLang, type Locale } from "@/i18n/config";

export async function fetchCategoriaConcesiones(
  lang: Locale,
  tipoCategoria?: string,
): Promise<CategoriaConcesiones[]> {
  const res = await fetchWithRetry<{ data: CategoriaConcesiones[] }>(
    `/categorias-concesiones?lang=${cmsLang(lang)}`,
  );
  return res.data
    .map((item) => ({
      nombre: item.nombre,
      tipo_codigo: item.tipo_codigo,
    }))
    .filter((item) =>
      tipoCategoria
        ? item.tipo_codigo.toLowerCase() === tipoCategoria.toLowerCase()
        : true,
    );
}
